import PropTypes from "prop-types"
import { useBreakpoints } from "modules/window/hooks/useBreakpoints"
import { Modal } from "ui/Modal"
import CustomDrawer from "ui/Drawer"
import StripeWrapper from "components/stripe/StripeWrapper"
import TakePaymentForm from "./TakePaymentForm"

const TakePaymentModal = ({ onOpen, onClose, remainingBalance, bookingUUID, bookingId, bookingTitle, bookedOn, clientName, clientEmail, experienceAvatar, balanceTaxesAndFees, balanceFeeItems, orderUuid, orderExperiences }) => {
  const breakpoint = useBreakpoints()
  const isMobile = ["xs", "xsm", "sm", "md"].includes(breakpoint)

  const content = (
    <StripeWrapper>
      <TakePaymentForm
        remainingBalance={remainingBalance}
        bookingUUID={bookingUUID}
        bookingId={bookingId}
        onClose={onClose}
        bookingTitle={bookingTitle}
        bookedOn={bookedOn}
        clientName={clientName}
        clientEmail={clientEmail}
        experienceAvatar={experienceAvatar}
        balanceTaxesAndFees={balanceTaxesAndFees}
        balanceFeeItems={balanceFeeItems}
        orderUuid={orderUuid}
        orderExperiences={orderExperiences}
      />
    </StripeWrapper>
  )

  return isMobile ? (
    <CustomDrawer open={onOpen} setOpen={onClose} title="Collect Payment">
      {content}
    </CustomDrawer>
  ) : (
    <Modal centered title="Collect Payment" open={onOpen} onCancel={onClose} width={1080} maskClosable={false}>
      {content}
    </Modal>
  )
}

TakePaymentModal.propTypes = {
  onOpen: PropTypes.bool,
  onClose: PropTypes.func,
  remainingBalance: PropTypes.number,
  bookingUUID: PropTypes.string,
  bookingId: PropTypes.number,
  bookingTitle: PropTypes.string,
  bookedOn: PropTypes.string,
  clientName: PropTypes.string,
  clientEmail: PropTypes.string,
  experienceAvatar: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  balanceTaxesAndFees: PropTypes.number,
  balanceFeeItems: PropTypes.array,
  orderUuid: PropTypes.string,
  orderExperiences: PropTypes.array
}

export default TakePaymentModal
